import { useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { type z } from 'zod';

import { type StudentSchema, type TeacherSchema } from '../schema';

import { useGetSubjectsByCountry } from './useGetSubjectsByCountry';

/*
 * 회원가입 폼 작성할 때
 * 선택한 학교 유형과 학년을 기준으로 학교 유형 코드와 학년 코드를 설정하는 훅입니다.
 */

export const toSchoolCodes = (categoryTreeId: string) => ({
  schoolTypeCode: categoryTreeId.slice(0, 3),
  schoolGradeCode: categoryTreeId.slice(0, 5),
});

export const useSetSchoolTypeAndGradeCode = () => {
  const { setValue, control } =
    useFormContext<z.infer<typeof TeacherSchema | typeof StudentSchema>>();
  const countryCode = useWatch({ control, name: 'countryCode' });
  const schoolGrade = useWatch({ control, name: 'schoolGrade' });
  const schoolType = useWatch({ control, name: 'schoolType' });

  const { data: subjects } = useGetSubjectsByCountry({
    countryCode,
    schoolType: schoolType ?? '',
    grade: isNaN(Number(schoolGrade)) ? 0 : Number(schoolGrade),
  });

  useEffect(() => {
    if (!subjects?.[0]?.categoryTreeId) return;

    const { schoolTypeCode, schoolGradeCode } = toSchoolCodes(
      subjects[0].categoryTreeId,
    );

    setValue('schoolTypeCode', schoolTypeCode);
    setValue('schoolGradeCode', schoolGradeCode);
  }, [subjects, setValue, schoolType, schoolGrade]);

  return null;
};
